
































import { NotificationCategory } from '@/types/Notification.interface'
import { NotificationToggle } from '@/types/NotificationSetting.interface'
import Vue from 'vue'
export default Vue.extend({
    props: {
        notifications: {
            required: true,
            type: Array
        },
        type: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            expand: false
        }
    },
    methods: {
        onChange(val: boolean, key: string, module: NotificationCategory): void {
            this.$emit('toggleNotification', {
                type: this.type,
                category: module,
                key: key,
                val: val
            } as NotificationToggle)
        }
    }
})
